module.exports = __webpack_public_path__ + "img/creation.11bf7f67.png";